import Services from 'store/Services';
import { updateExchangeRateOnCurrencyChangedMiddleware } from 'app/currencies/store/middleware';
import {
    ordersMessageReceiveBatchSanitizer,
    orderStreamUpdatedEventSanitizer,
    ordersFilterResultsChangedSanitizer,
} from './orders/actionSanitizers';
import { portfolioSummarySetAggregatedDataActionSanitizer } from 'widgets/portfolioSummary/store/data/actionSanitizers';
import { shareUsersSetActionSanitizer } from 'app/store/shareUsers/actionSanitizer';
import { environment } from 'environment';
import { portfolioSetSelectionActionSanitizer } from 'portfolio/store/actionSanitizers.ts';

export const middleware = (_services: Services) => [
    updateExchangeRateOnCurrencyChangedMiddleware,
];

export const actionSanitizers = [
    portfolioSummarySetAggregatedDataActionSanitizer,
    ordersMessageReceiveBatchSanitizer,
    orderStreamUpdatedEventSanitizer,
    ordersFilterResultsChangedSanitizer,
    shareUsersSetActionSanitizer,
    portfolioSetSelectionActionSanitizer,
];
export const DevToolsActionSanitizers = environment.sanitizeMessages
    ? actionSanitizers
    : [];
